import { Observable, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ContentType } from '@lib/api/entities';

@Injectable({
  providedIn: 'root',
})
export class ContentTypesAPI {
  private _contentTypes: ContentType[];

  constructor(private readonly _httpClient: HttpClient) {}

  public getList(): Observable<ContentType[]> {
    if (!this._contentTypes) {
      return this._httpClient
        .get('/api/core/contrib/contenttypes/', { params: { pageSize: 'all' } })
        .pipe(
          map((response: any) => response.results),
          tap((response) => {
            this._contentTypes = response;
          }),
        );
    }
    return of(this._contentTypes);
  }

  public getType(type: string): Observable<number> {
    return this.getList().pipe(
      switchMap(() => {
        const match = this._contentTypes.find((t) => {
          return t.model === type;
        });
        return of(match?.id);
      }),
    );
  }
}
